/**
 * PDP chat control (PDPBAR-1, PRD D3). Only theme asset allowed to name the chat vendor.
 * Vendor launcher is hidden by CSS, never removed — the global resolves it at call time.
 */
export const CHAT_TRIGGER_ID = 'Avada-FAQ_WidgetTrigger';
export const CHAT_GLOBAL_NAME = 'avadaFaqTrigger';
export const CHAT_CONTROL_ID = 'pb-bar-chat';
export const CHAT_FALLBACK_CLASS = 'pb-chat-fallback';
/** Vendor loads off a 100ms x 50 poll; give up a little after that. */
export const CHAT_READY_DEADLINE_MS = 8000;

/** 'enabled' | 'not-ready' | 'fall-back' — never enable on a timer alone. */
export function resolveChatState({ hasGlobal, hasTrigger, deadlinePassed }) {
  if (hasGlobal && hasTrigger) return 'enabled';
  return deadlinePassed ? 'fall-back' : 'not-ready';
}

export function readChatEnvironment(win) {
  const doc = win && win.document;
  return {
    hasGlobal: !!win && typeof win[CHAT_GLOBAL_NAME] === 'function',
    hasTrigger: !!(doc && doc.getElementById && doc.getElementById(CHAT_TRIGGER_ID)),
  };
}

export function openChat(win) {
  const scope = win || (typeof window === 'undefined' ? null : window);
  const env = readChatEnvironment(scope);
  if (resolveChatState({ ...env, deadlinePassed: false }) !== 'enabled') return false;
  try {
    scope[CHAT_GLOBAL_NAME]();
    return true;
  } catch {
    return false;
  }
}

export function boot(win) {
  const doc = win.document;
  const control = doc.getElementById(CHAT_CONTROL_ID);
  if (!control) return;
  const startedAt = Date.now();
  let observer = null;
  let timer = null;

  function fallBack() {
    control.remove();
    if (doc.body) doc.body.classList.add(CHAT_FALLBACK_CLASS);
  }

  function apply() {
    const state = resolveChatState({
      ...readChatEnvironment(win),
      deadlinePassed: Date.now() - startedAt >= CHAT_READY_DEADLINE_MS,
    });
    if (state === 'not-ready') return false;
    if (observer) observer.disconnect();
    if (timer) win.clearTimeout(timer);
    if (state !== 'enabled') {
      fallBack();
      return true;
    }
    control.disabled = false;
    control.removeAttribute('hidden');
    control.setAttribute('data-pb-chat-state', 'enabled');
    return true;
  }

  control.addEventListener('click', () => {
    if (!openChat(win)) fallBack();
  });
  if (apply()) return;
  timer = win.setTimeout(apply, CHAT_READY_DEADLINE_MS);
  if (typeof win.MutationObserver === 'function' && doc.body) {
    observer = new win.MutationObserver(apply);
    observer.observe(doc.body, { childList: true, subtree: true });
  }
}

if (typeof document !== 'undefined' && document.getElementById && document.getElementById(CHAT_CONTROL_ID)) {
  boot(window);
}
